// extracted by mini-css-extract-plugin
export var leftAlign = "_30-2";
export var popper = "_30-0";
export var subtitle = "_30-1";